module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG73af1aac1895811916c4d599bdd56c76.73af1aac.png";